export { default } from "./SmartOfferCard";
